// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_5k-4";
export var collapsed = "_5k-1";
export var headerBar = "_5k-0";
export var leftHeaderContent = "_5k-3";
export var subjectContainer = "_5k-2";